<template>
	<div class="page">
		<div class="pageTitleBox">
			<div class="boxNameL">
				新建挂号
			</div>
			<div class="boxNameR">
				<el-button type="success" size="small" @click="dialogState_addVip=true">新建顾客档案</el-button>
			</div>
		</div>
		<div class="pageConBox">
			<el-form :inline="true" style="padding-top:30px;">
				<el-row>
					<el-col :span="6">
						<el-form-item label="顾客名称：" :label-width="formLabelWidth">
							<remoteVipSelect style="width:220px" :propsVipInfo="propsVipInfo" @getCurVipItem="getCurVipItem"></remoteVipSelect>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="手机号：" :label-width="formLabelWidth">
							<el-input :rows="4" :value="userInfo.basic_info&&userInfo.basic_info.user_mobile" disabled style="width:220px"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="6">
						<el-form-item label="宠物昵称：" :label-width="formLabelWidth">
							<remotePetSelect style="width:220px;display: inline-block;" :propsPetList="propsPetList" @getCurPetItem="getCurPetItem"></remotePetSelect>
							<el-button v-if="userInfo._id" type="success" size="small" @click="addPet">新增</el-button>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="品种：" :label-width="formLabelWidth">
							<el-input :rows="4" :value="petInfo.pet_type" disabled style="width:220px"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="性别：" :label-width="formLabelWidth">
							<el-input :rows="4" :value="$public.FSex([petInfo.pet_sex,petInfo.pet_sterilization])" disabled style="width:220px"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="年龄：" :label-width="formLabelWidth">
							<el-input :rows="4" :value="petInfo.pet_birthday" disabled style="width:220px"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="6">
						<el-form-item label="医生：" :label-width="formLabelWidth">
							<el-select style="width:100%;" v-model="curDoctorId" @change="changeDoctor" clearable placeholder="请选择医生">
								<el-option v-for="(item,index) in doctorList" :key="item._id" :label="item.basic_info.nick_name" :value="index">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="科室：" :label-width="formLabelWidth">
							<el-select style="width:100%;" v-model="curDepartmentId" placeholder="请选择科室">
								<el-option v-for="item in [{label:'内科',value:1},{label:'外科',value:2}]" :key="item.value" :label="item.label" :value="item.value"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="12">
						<el-form-item label="备注：" :label-width="formLabelWidth">
							<el-input type="textarea" v-model="remark" :rows="4" style="width:440px"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<div class="submitLine">
				<el-button type="primary" @click="submit">确定挂号</el-button>
			</div>
		</div>
		<dialogAddVip v-if="dialogState_addVip" :userInfo="userInfo" @submit="dialogSubmit"></dialogAddVip>
		<dialogAddEditPet v-if="dialogState_addPet" :userInfo="userInfo" :dialog_type="'addPet'" @submit="dialogPet_submit"></dialogAddEditPet>
	</div>
</template>
<script>
	import remoteVipSelect from "../../components/remoteVipSelect.vue"
	import remotePetSelect from "../../components/remotePetSelect.vue"
	import dialogAddVip from "../../components/dialogAddVip.vue"
	import dialogAddEditPet from "../../components/dialog_addEditPet.vue"
	export default {
		components:{remoteVipSelect,remotePetSelect,dialogAddVip,dialogAddEditPet},
		data(){
			return{
				formLabelWidth: '120px',
				dialogState_addVip:false,
				dialogState_addPet:false,
				// datetimerange:[],
				userInfo:{},
				petInfo:{},
				
				propsVipInfo:{},
				propsPetList:[],
				
				curDepartmentId:1,
				curDoctorId:'',
				doctorList:[],
				
				remark:'',
			}
		},
		watch:{
			
		},
		mounted(){
			this.$util.getDoctorList().then(list=>{
				this.doctorList = list;
			})
		},
		methods: {
			// 挂号
			submit(){
				let loading=this.$loading();
				if(!this.userInfo._id){
					this.$message({
						message: '请输入顾客名称',
						type: 'error'
					});
					return ;
				}
				if(!this.petInfo.pet_id){
					this.$message({
						message: '请输入宠物昵称',
						type: 'error'
					});
					return ;
				}
				let params = {
					departmentId:this.curDepartmentId,
					"memberId":this.userInfo._id,
					"memberName": this.userInfo.basic_info.nick_name,
					"memberMobile": this.userInfo.basic_info.user_mobile,
					"petId": this.petInfo.pet_id,
					"petName": this.petInfo.pet_name,
					"typeName": this.petInfo.pet_type,
					"sex": this.$public.FSex([this.petInfo.pet_sex,this.petInfo.pet_sterilization]),
					"birthDay": this.$public.FTime((''+new Date(this.petInfo.pet_birthday).getTime()).substr(0,10),'YYYY-MM-DD'),
					"doctorId": "",
					"doctorName": "",
					"remark": this.remark
				}
				if(this.curDoctorId!==''){
					params.doctorId = this.doctorList[this.curDoctorId]._id;
					params.doctorName = this.doctorList[this.curDoctorId].basic_info.nick_name;
				}
				this.$http.post('/api/Registration/Insert', params).then(res => {
					loading.close();
					if (res.code == 0) {
						this.$message({
							message: '操作成功',
							type: 'success'
						});
						this.propsPetList=''
						this.propsVipInfo=''
						this.petInfo={};
						this.userInfo={};
						this.curDepartmentId=1
						this.curDoctorId=''
						this.remark=''
						this.$router.push({path:'/yiliao/guahaoList'})
					}
				})
			},
			// 获取选中的顾客
			getCurVipItem(item){
				if(item){
					this.propsPetList = item;
					this.userInfo = item;
				}else{
					this.propsPetList = [];
					this.userInfo = {};
				}
			},
			// 获取选中的宠物
			getCurPetItem(item){
				if(item){
					this.propsVipInfo=item;
					this.petInfo=item;
				}else{
					this.propsVipInfo={};
					this.petInfo={};
				}
			},
			// 新增宠物
			addPet(){
				this.dialogState_addPet = true;
			},
			// 选择医生
			changeDoctor(index){
				this.curDoctorId = index;
			},
			dialogSubmit(a){
				this.dialogState_addVip = false;
				if(a){
					let b = {
						"member_id":a._id,
						"member_name":a.basic_info.nick_name,
						"member_mobile":a.basic_info.user_mobile,
						"member_type":a.club_card. surplus_day,
						"member_yue":a.card_info.user_yue,
						"member_zenge":a.card_info.user_zenge,
						"pet_id":a.pets_info[0]._id,
						"pet_name":a.pets_info[0].nick_name,
						"pet_type":a.pets_info[0].type_name,
						"pet_class":a.pets_info[0].class_name,
						"pet_birthday":a.pets_info[0].birth_day,
						"pet_sex":a.pets_info[0].sex,
						"pet_sterilization":a.pets_info[0].sterilization,
						"hs_pet":a.pets_info[0].hs_pet
					}
					this.propsVipInfo = b;
					this.dialogState_addVip = false;
				}
			},
			dialogPet_submit(petId){
				this.dialogState_addPet = false;
				if(petId.length>10){
					this.$util.getVipList(this.userInfo._id).then(list=>{
						this.userInfo = list[0]
					})
					this.propsVipInfo=''
					this.propsPetList=''
					this.$util.getPetList(petId).then(list=>{
						this.petInfo = list[0]
						this.propsVipInfo = list[0]
					})
				}
			}
		}
	}
</script>
<style scoped lang="scss">
.page{
	
}
</style>
